/* Peakside Facelift 2026 — product-page field checks for the option-app (BCPO) text boxes.
   Brent 2026-10-12:
   - every VIN box is checked as it's typed (17 characters, no I / O / Q, position-9 check digit)
   - on SCT products the device serial number must be exactly 13 characters
   A bad value shows a message under the box and stops Add To Cart until it is fixed.
   Loaded by sections/main-product.liquid; styles live in assets/pk-product.css (.pk-field-note). */
(function () {
  'use strict';

  var VIN_TRANSLIT = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
  var VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  var SCT_SERIAL_LENGTH = 13;

  function cleanVin(v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  function vinCheckDigitOk(vin) {
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      var c = vin.charAt(i);
      var n = /[0-9]/.test(c) ? Number(c) : VIN_TRANSLIT[c];
      if (n === undefined) return false;
      sum += n * VIN_WEIGHTS[i];
    }
    var rem = sum % 11;
    return vin.charAt(8) === (rem === 10 ? 'X' : String(rem));
  }

  function vinProblem(vin) {
    if (!vin) return '';
    if (vin.length !== 17) return 'A VIN is 17 characters — this one has ' + vin.length + '.';
    if (/[IOQ]/.test(vin)) return 'VINs never use the letters I, O or Q — those are usually a 1 or a 0.';
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) return 'That VIN has a character we don\'t recognise — check it against the door jamb sticker.';
    if (!vinCheckDigitOk(vin)) return 'That VIN doesn\'t pass its check digit — one character is probably mistyped.';
    return '';
  }

  function sctSerialProblem(serial) {
    if (!serial) return '';
    if (serial.length !== SCT_SERIAL_LENGTH) return 'SCT device serial numbers are exactly ' + SCT_SERIAL_LENGTH + ' characters — this one has ' + serial.length + '.';
    return '';
  }

  // ---- which boxes to watch ----
  var sctProduct = null;
  function isSctProduct() {
    if (sctProduct !== null) return sctProduct;
    var title = document.querySelector('.product__title');
    var text = (title ? title.textContent : '') + ' ' + window.location.pathname;
    sctProduct = /\bsct\b/i.test(text) || /-sct-/i.test(window.location.pathname);
    if (!sctProduct) {
      // SCT tune products ask for an ECU / TCU strategy code
      var wrappers = document.querySelectorAll('#bcpo .selector-wrapper');
      for (var i = 0; i < wrappers.length; i++) {
        if (/\b(ECU|TCU) Strategy\b/i.test(wrappers[i].textContent)) { sctProduct = true; break; }
      }
    }
    return sctProduct;
  }

  function keyFor(input) {
    var wrap = input.closest('.selector-wrapper');
    var label = wrap && (wrap.querySelector('.bcpo-label') || wrap.querySelector('label'));
    return ((label && label.textContent) || '') + ' ' + (input.name || '');
  }

  function kindOf(input) {
    if (!input || input.tagName !== 'INPUT' || (input.type && input.type !== 'text')) return '';
    if (!input.closest('#bcpo')) return '';
    var key = keyFor(input);
    if (/\bVIN\b/i.test(key)) return 'vin';
    if (/serial|s\/n/i.test(key) && !/\b(ECM|ECU|TCU|PCM|VIN|order)\b/i.test(key) && isSctProduct()) return 'sct';
    return '';
  }

  // ---- feedback ----
  function noteFor(input) {
    // VIN boxes sit inside the scanner wrapper (input + camera button): the note goes after the wrapper
    var anchor = input.closest('.pk-vin-scan') || input;
    var note = anchor.nextElementSibling;
    if (!note || !note.classList || !note.classList.contains('pk-field-note')) {
      note = document.createElement('small');
      note.className = 'pk-field-note';
      note.hidden = true;
      anchor.insertAdjacentElement('afterend', note);
    }
    return note;
  }

  function show(input, text, state) {
    var note = noteFor(input);
    var wrap = input.closest('.selector-wrapper') || input.parentElement;
    note.textContent = text || '';
    note.hidden = !text;
    note.className = 'pk-field-note' + (state ? ' pk-field-note--' + state : '');
    if (wrap) wrap.classList.toggle('pk-field--error', state === 'error');
  }

  // Returns the problem text (empty when fine). `final` = checking before Add To Cart.
  function check(input, final) {
    var kind = kindOf(input);
    if (!kind) return '';
    if (kind === 'vin') {
      var vin = cleanVin(input.value);
      if (input.value !== vin) input.value = vin;
      if (!vin) { show(input, final ? 'Please enter your 17-character VIN.' : '', final ? 'error' : ''); return final ? 'missing' : ''; }
      var problem = vinProblem(vin);
      if (!problem) { show(input, 'VIN looks good.', 'ok'); return ''; }
      if (final || vin.length >= 17 || /[IOQ]/.test(vin)) show(input, problem, 'error');
      else show(input, vin.length + ' of 17 characters', '');
      return problem;
    }
    var serial = String(input.value || '').replace(/\s+/g, '');
    if (input.value !== serial) input.value = serial;
    if (!serial) { show(input, final ? 'Please enter your ' + SCT_SERIAL_LENGTH + '-character SCT device serial number.' : '', final ? 'error' : ''); return final ? 'missing' : ''; }
    var sp = sctSerialProblem(serial);
    if (!sp) { show(input, 'Serial number looks good.', 'ok'); return ''; }
    if (final || serial.length > SCT_SERIAL_LENGTH) show(input, sp, 'error');
    else show(input, serial.length + ' of ' + SCT_SERIAL_LENGTH + ' characters', '');
    return sp;
  }

  function firstBadField() {
    var inputs = document.querySelectorAll('#bcpo input[type="text"], #bcpo input:not([type])');
    var bad = null;
    for (var i = 0; i < inputs.length; i++) {
      if (!kindOf(inputs[i])) continue;
      if (check(inputs[i], true) && !bad) bad = inputs[i];
    }
    return bad;
  }

  function block(evt, field) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    try { field.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* older browsers */ }
    field.focus();
  }

  document.addEventListener('input', function (evt) {
    if (kindOf(evt.target)) check(evt.target, false);
  });

  // Brent 2026-10-13: camera button (assets/pk-vin-scan.js) beside every VIN box. The options app renders its
  // boxes after load and can rebuild them, so re-check whenever the page changes (attach is idempotent).
  var attachTimer = 0;
  function attachScanners() {
    attachTimer = 0;
    if (!window.PkVinScan) return;
    var inputs = document.querySelectorAll('#bcpo input[type="text"], #bcpo input:not([type])');
    for (var i = 0; i < inputs.length; i++) {
      if (kindOf(inputs[i]) === 'vin') window.PkVinScan.attach(inputs[i]);
    }
  }
  function scheduleAttach() {
    if (!attachTimer) attachTimer = window.setTimeout(attachScanners, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleAttach);
  else scheduleAttach();
  if (window.MutationObserver) {
    new MutationObserver(scheduleAttach).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Add To Cart: stop the submit (capture phase runs before Dawn's product-form handler and the options app)
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.getAttribute || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    var bad = firstBadField();
    if (bad) block(evt, bad);
  }, true);

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('.product-form__submit, button[name="add"]') : null;
    if (!btn) return;
    var bad = firstBadField();
    if (bad) block(evt, bad);
  }, true);
})();
